<div>
  <div class="flex items-center mb-1">
    <!-- <h2 mat-dialog-title class="text-lg font-bold mb-1"></h2> -->
    <mat-icon svgIcon="heroicons_outline:x-circle" matTooltip="Cerrar" class="close-button" mat-dialog-close
      style="cursor: pointer;"></mat-icon>
  </div>

  <mat-dialog-content class="modal-content">
    <!-- Payment summary for payment modal -->
    <div *ngIf="isPaymentModal" class="mb-4 p-4rounded-lg">
      <h3 class="text-xl font-bold mb-2">Detalles del Pago</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="font-bold">Tipo de Pago:</span> {{ data?.paymentInfo?.paymentType?.name }}
        </div>
        <div>
          <span class="font-bold">Total Esperado:</span> {{ data?.paymentAmount | number:'1.2-2' }}
        </div>
        <div>
          <span class="font-bold">Total Calculado:</span> {{ getTotalPaymentAmount() | number:'1.2-2' }}
        </div>
        <div *ngIf="data?.paymentInfo?.bank">
          <span class="font-bold">Banco:</span> {{ data?.paymentInfo?.bank?.name }}
        </div>
      </div>
    </div>

    <div class="top-0">
      <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceHistoric" matSort>

        <!-- Payment Modal Columns -->
        <ng-container *ngIf="isPaymentModal" matColumnDef="documentSerial">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Nro. Doc</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-left">
            <span class="table-text-code">{{payment?.serials}}</span>
          </td>
        </ng-container>

        <ng-container *ngIf="isPaymentModal" matColumnDef="payer">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Factura</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-left">
            <app-document-navigation [documentType]="documentTypeEnum.FACTURA" [documentSerial]="payment?.document"></app-document-navigation>
          </td>
        </ng-container>

        <ng-container *ngIf="isPaymentModal" matColumnDef="destinatary">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cliente</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-left leading-tight max-w-[240px]">
            <p class="table-text-m break-words">
              <span class="table-text-code">{{payment?.shipTo?.externalKeys?.code}}</span><br>
              <span>{{ payment?.shipTo?.name }}</span>
            </p>
          </td>
        </ng-container>

        <ng-container *ngIf="isPaymentModal" matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Tipo de Pago</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-left">
            <p class="table-text-m">{{payment?.paymentMethod?.name}}</p>
          </td>
        </ng-container>
        
        <ng-container *ngIf="isPaymentModal" matColumnDef="overpayment">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right">Sobrepago</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-right">
            <span class="f-12">{{payment?.overpayment | number: '1.2-2'}}</span>
          </td>
        </ng-container>

        <ng-container *ngIf="isPaymentModal" matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right">Monto</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-right">
            <span class="f-12 font-semibold">
              {{ getTotalAmount(payment) | number:'1.2-2' }}
            </span>
          </td>
        </ng-container>

        <ng-container *ngIf="isPaymentModal" matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-right">Total</th>
          <td mat-cell *matCellDef="let payment" class="px-6 text-right">
            <span class="f-12 font-semibold">
              {{ (getTotalAmount(payment) + (payment?.overpayment ?? 0)) | number:'1.2-2' }}
            </span>
          </td>
        </ng-container>

        <!-- Original Order Columns -->
        <ng-container *ngIf="!isPaymentModal" matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col">
            <mat-checkbox color="primary" (change)="
                  $event ? masterToggle() : null; onCheckboxChange($event)
                " [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <mat-checkbox color="primary" (click)="
                  $event.stopPropagation(); onCheckboxChange($event, element)
                " (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"
              [aria-label]="checkboxLabel(element)" [disabled]="!validateOrdersByAction(element)  && !element.canJoin">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="serial">
          <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Nro. Doc</th>
          <td mat-cell *matCellDef="let historic" class="px-6 min-w-[250px]">
            <app-document-navigation [documentType]="historic?.type?.code" [documentSerial]="historic?.serial"></app-document-navigation>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="documentClass">
          <th mat-header-cell *matHeaderCellDef class="px-6">Clase de Documento</th>
          <td mat-cell *matCellDef="let historic" class="px-6">
            <span >{{historic?.class?.name}}</span>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="soldTo">
          <th mat-header-cell *matHeaderCellDef class="px-6">Pagador</th>
          <td mat-cell *matCellDef="let historic" class="px-6 text-left">
            <p class="table-text-m" style="min-width: 102px;">
              <span class="table-text-code">{{historic?.soldTo?.externalKeys?.code}}</span><br>
              <span style="display: flex; align-items: center;">
                @switch (historic.shipToType) {
                @case ('BPT9001') {
                <span class="cursor-pointer" matTooltip="Consumidor Final">
                  <mat-icon style="color: #1976d2;">person_outline</mat-icon>
                </span>
                }
                @case ('BPT9002') {
                <span class="cursor-pointer" matTooltip="Cliente Eventual">
                  <mat-icon style="color: #2e7d32;">person</mat-icon>
                </span>
                }
                }
                {{ historic?.soldTo?.name }}
              </span>
            </p>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="shipTo">
          <th mat-header-cell *matHeaderCellDef class="px-6">Destinatario</th>
          <td mat-cell *matCellDef="let historic" class="px-6">
            <p class="table-text-m" style="min-width: 102px;">
              <span class="table-text-code">{{historic?.shipTo?.externalKeys?.code}}</span><br>
              <span style="display: flex; align-items: center;">
                @switch (historic.shipToType) {
                @case ('BPT9001') {
                <span class="cursor-pointer" matTooltip="Consumidor Final">
                  <mat-icon style="color: #1976d2;">person_outline</mat-icon>
                </span>
                }
                @case ('BPT9002') {
                <span class="cursor-pointer" matTooltip="Cliente Eventual">
                  <mat-icon style="color: #2e7d32;">person</mat-icon>
                </span>
                }
                }
                {{ historic?.shipTo?.name }}
              </span>
            </p>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="quantities">
          <th mat-header-cell *matHeaderCellDef class="px-6">
            {{ isPaymentContext ? 'Monto' : 'Cnt. Solicitada' }}
          </th>
          <td mat-cell *matCellDef="let historic" class="px-6">
            <!-- Original quantities display for non-payment context -->
            <ng-container *ngIf="!isPaymentContext">
              <ng-container *ngIf="getFirstDetail(historic) as detail">
                <app-unit-measure-display
                  class="table-text-m-2 pd-l f-9"
                  [baseUnit]="{
                    quantity: detail?.baseQuantity,
                    unitId: detail?.baseUnitOfMeasure?._id,
                    unitName: detail?.baseUnitOfMeasure?.name,
                    unitAbbreviation: detail?.baseUnitOfMeasure?.code
                  }"
                  [parallelUnit]="{
                    quantity: detail?.pararellQuantity,
                    unitId: detail?.pararellUnitOfMeasure?._id,
                    unitName: detail?.pararellUnitOfMeasure?.name,
                    unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                  }"
                  [material]="{
                    _id: detail?.material?._id,
                    code: detail?.material?.code,
                    UMPActive: detail?.material?.UMPActive ?? false
                  }"
                  [companyUMPActive]="data.UMPActive"
                  [statusId]="detail.statusId"
                ></app-unit-measure-display>
              </ng-container>
            </ng-container>
            <!-- Payment amount display for payment context -->
            <ng-container *ngIf="isPaymentContext">
              <p class="table-text-m-2 text-right">
                <span class="f-12 font-semibold">
                  {{ getTotalAmount(historic) | number:'1.2-2' }}
                </span>
              </p>
            </ng-container>
          </td>
        </ng-container>

        <ng-container *ngIf="!isPaymentModal" matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-left first-col" style="min-width: 40px">
            <!-- Menú desplegable (solo para DT003) -->
            <button *ngIf="selection.selected.length > 0" mat-icon-button [matMenuTriggerFor]="actionOrder"
              matTooltip="Acciones">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #actionOrder="matMenu">
              <button *ngIf="canJoin" mat-menu-item (click)="openMConfirmDialog()" [disabled]="isNoOrderSelectionJoin">
                <mat-icon svgIcon="heroicons_outline:squares-plus"></mat-icon>
                <span>Unificar</span>
              </button>
            </mat-menu>

          </th>
          <td mat-cell *matCellDef="let element" class="text-left first-col">
            <!-- <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
      

            </mat-menu> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="isPaymentModal ? displayedColumnsPayment : displayedColumnsHistoric"
          class="bg-gray-100 dark:bg-gray-900"></tr>
        <tr mat-row *matRowDef="let row; columns: isPaymentModal ? displayedColumnsPayment : displayedColumnsHistoric;"
          class="border-b"></tr>
      </table>
    </div>

    <!-- <mat-dialog-actions class="modal-actions flex justify-end">
            <button mat-button (click)="onClose()" class="align-left">
                Cancelar
            </button>
            <button mat-raised-button color="primary" (click)="openConfirmDialog()">
                Guardar
            </button>
        </mat-dialog-actions> -->
  </mat-dialog-content>
</div>


<ng-template #confirmDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{data.title}}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p *ngIf="data.message">{{data.message}}</p>
        <div *ngIf="data.innerHTML" [innerHTML]="data.innerHTML"></div>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Conservar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>